export const SEO_BASE_URL = 'https://balancepath.space';

export const DEFAULT_OG_IMAGE = `${SEO_BASE_URL}/balance-path.jpg`;

export const DEFAULT_OG_IMAGE_ALT = 'BalancePath - Online Psychotherapy Platform';

export const TWITTER_SITE = '@BalancePath';

export const TWITTER_CREATOR = '@BalancePath';

/** Društvene mreže — koristi se u Organization JSON-LD (sameAs). */
export const ORGANIZATION_SAME_AS: string[] = [
    'https://www.facebook.com/profile.php?id=61586537354518',
    'https://www.instagram.com/balance.path/',
    'https://www.linkedin.com/company/balancepath/',
];
